module.exports = __webpack_public_path__ + "static/IMG_0063.c623732d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/examples/IMG_0063.jpg
// module id = 573
// module chunks = 35783957827783